<ng-container *transloco="let t; prefix: 'orders'">
  @if (ready()) {
  @if (proposal()?.dataInserimento) {
    <span class="proposal-created body-small">{{ 'orders.ui.creataIl' | transloco: { value0: (proposal()?.dataInserimento | date: 'dd/MM/yyyy HH:mm') } }}</span>
  }

  <div class="proposal-cards">
    <div class="proposal-card" [class.proposal-card--selected]="customerSelected()">
      <div class="proposal-card-icon" aria-hidden="true">
        <i [class]="(customerSelected() ? 'fa-solid' : 'fa-regular') + ' fa-user'"></i>
      </div>

      <div class="proposal-card-info">
        <span class="title-medium-emphasized">{{ 'orders.ui.cliente' | transloco }}</span>
        <span class="body-medium">{{ customer()?.ragioneSociale ?? ('orders.ui.aggiungiIlClientePerIniziare' | transloco) }}</span>
        @if (customer()?.codes) {
          <span class="body-medium">{{ customer()?.codes }}</span>
        }
      </div>

      <button matButton type="button" class="proposal-card-action" (click)="openSelectCustomer()">
        {{ customerSelected() ? ('orders.ui.modifica' | transloco) : ('orders.ui.aggiungi' | transloco) }}
      </button>
    </div>

    <div class="proposal-card" [class.proposal-card--selected]="productsSelected()">
      <div class="proposal-card-icon" aria-hidden="true">
        <i [class]="(productsSelected() ? 'fa-solid' : 'fa-regular') + ' fa-box'"></i>
      </div>

      <div class="proposal-card-info">
        <span class="title-medium-emphasized">{{ 'orders.ui.prodotti' | transloco }}</span>
        <span class="body-medium">
          @if (productsCount() > 0) {
            {{ 'orders.ui.articoli' | transloco: { value0: (productsCount()) } }}
          } @else {
            {{ 'orders.ui.aggiungiProdottiAllaProposta' | transloco }}
          }
        </span>
      </div>

      <button matButton type="button" class="proposal-card-action" (click)="openSelectProducts()">
        {{ productsSelected() ? ('orders.ui.modifica' | transloco) : ('orders.ui.aggiungi' | transloco) }}
      </button>
    </div>
  </div>

  <div class="proposal-anomalies">
    <ord-proposal-anomalies />
  </div>

  @if (proposal()?.nuovoCliente) {
    <ord-new-customer-request-banner class="proposal-new-customer" />
  }

  <button
    matButton="filled"
    type="button"
    class="proposal-continue-button"
    [disabled]="!canContinue()"
    (click)="continueToShipping()"
  >
    {{ 'orders.ui.prosegui' | transloco }}
  </button>
  }
</ng-container>
